import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

const propTypes = {
  checked: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
  inline: PropTypes.bool,
  label: PropTypes.any,
  name: PropTypes.string,
  onClick: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

const Radio = ({ checked, inline, label, name, onBlur, onChange, value }) => {
  const id = `radio--${name}-${value}`;
  const containerClasses = cn('custom-control', 'custom-radio', { 'custom-control-inline': inline });

  return (
    <div className={containerClasses}>
      <input
        type="radio"
        id={id}
        name={name}
        value={value}
        className="custom-control-input"
        checked={checked == value}
        onBlur={onBlur}
        onChange={onChange}
      />
      <label className="custom-control-label" htmlFor={id}>
        {label}
      </label>
    </div>
  );
};

Radio.propTypes = propTypes;

export default Radio;
